import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";
import { ICaste } from "../../../feature-module/pages/masters/caste";

interface ICasteState {
  data: ICaste[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: ICasteState = {
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const getAllCastes = createAsyncThunk(
  'get/allCastes',
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.MASTERS.FIND_ALL_CASTE,
        payload
      );
      return response.data.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const casteSlice = createSlice({
  name: "caste",
  initialState,
  reducers: {
    resetCasteState: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.total = 0;
      state.page = 1;
      state.limit = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCastes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCastes.fulfilled, (state, action) => {
        const payload = action.payload;
        state.loading = false;
        state.data = payload.data || [];
        state.total = payload.total || 0;
        state.page = payload.page || 1;
        state.limit = payload.limit || 10;
        state.error = null;
      })
      .addCase(getAllCastes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = [];
      });
  },
});

export const { resetCasteState } = casteSlice.actions;
export default casteSlice.reducer;